import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import * as S from './FAQAccordion.styles';

/**
 * Reusable FAQ accordion component.
 */
const FAQAccordion = ({ items = [], defaultOpenIndex = 0 }) => {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);

  const toggleIndex = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  if (!items || items.length === 0) return null;

  return (
    <S.FAQList>
      {items.map((item, idx) => {
        const isOpen = openIndex === idx;
        return (
          <S.FAQItem key={idx} onClick={() => toggleIndex(idx)}>
            <S.FAQHeader>
              <S.FAQQuestion>{item.question}</S.FAQQuestion>
              <S.FAQIcon $isOpen={isOpen}>
                <FaChevronDown />
              </S.FAQIcon>
            </S.FAQHeader>
            <S.FAQAnswer $isOpen={isOpen}>
              <S.FAQAnswerContent>{item.answer}</S.FAQAnswerContent>
            </S.FAQAnswer>
          </S.FAQItem>
        );
      })}
    </S.FAQList>
  );
};

export default FAQAccordion;
